const middlewares = []

declare let __CLIENT__: boolean

if (__CLIENT__) {
  middlewares.push(require('./middlewares/sessionStorage').default)
}

export default middlewares
